import React from 'react';
import LQALogo from '../../components/commons/icons/lqa';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import {
  WelcomeContainer,
  TopSection,
  BottomSection,
  WelcomeContent,
} from './Welcome.styled';

const Welcome = () => {
  const getStartedHandler = () => {
    window.location.href = '/register/activationCode';
  };
  const getSignInHandler = () => {
    window.location.href = '/login';
  };
  return (
    <WelcomeContainer>
      <WelcomeContent>
        <TopSection>
          <LQALogo width={140} height={140} />
        </TopSection>
        <BottomSection>
          <ButtonLarge
            backgroundColor="oxfordBlueDark"
            title="Register"
            outlined={true}
            inverted={true}
            onClick={() => {
              getStartedHandler();
            }}
          />
          <ButtonLarge
            backgroundColor="oxfordBlueDark"
            title="Sign In"
            outlined={true}
            onClick={() => {
              getSignInHandler();
            }}
          />
        </BottomSection>
      </WelcomeContent>
    </WelcomeContainer>
  );
};

export default Welcome;
